import type { Customer } from './customerModel';

/** UX board/list stages (single source of truth for onboarding dashboard). */
export type JourneyStage =
  | 'request'
  | 'domainApproval'
  | 'domainCreate'
  | 'masterData'
  | 'complete';

export const JOURNEY_STAGE_VALUES: readonly JourneyStage[] = [
  'request',
  'domainApproval',
  'domainCreate',
  'masterData',
  'complete',
] as const;

export type SuluStatus =
  | 'notStarted'
  | 'needsPartnerMaster'
  | 'inProgress'
  | 'complete'
  | 'failed';

/** Extra list fields beyond core Customer (no separate journeyStage — use onboardingStatus). */
export type CustomerDashboardFields = {
  /** Display label for stage chip, e.g. "Approval". If omitted, UI derives from onboardingStatus. */
  onboardingStatusLabel?: string;
  nextAction: string;
  nextActionOwner: string;
  suluStatus: SuluStatus;
  suluStatusLabel: string;
  isRejected?: boolean;
  stageColumnOwner?: string;
};

export type OnboardingDashboardCustomer = Customer & CustomerDashboardFields;
